module.exports = __webpack_public_path__ + "static/media/Timer_COLLECT@3x.9636c056.png";